import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "20",
      d: "M36 168q0-38 34-38 40 0 40-30T80 70 50 50M130 60q0-24 24-24t24 24q0 20-16 20t-16-16"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "172",
      cy: "56",
      r: "4",
      fill: "var(--mc-avatar)"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "3",
      d: "m178 60 14-4m-14 4 14 4"
    }, null, -1)
  ]))]))
}
export default { render: render }